import type {SliceLike, SliceZoneComponents} from '@prismicio/vue';
import {marketingSlicesComponents, navbarUnloggedSlicesComponents, sharedSlicesComponents} from '#imports';
import {components as cmsComponents} from './index';

export const components = {
    ...sharedSlicesComponents,
    ...marketingSlicesComponents,
    ...navbarUnloggedSlicesComponents,
    ...cmsComponents,
} as SliceZoneComponents<SliceLike<string>, unknown>;
